import {FooterTabFragment} from "../../shared/FooterTabFragment";
import React from "react";
import {Box} from "@mui/material";
import {TabInfo, Tabs} from "../../shared/TabsContainer";
import {GAMES, GameTabType} from "../Games";
import {
  HeaderTabsContainer,
  HeaderTabsContainerProps,
  HeaderTabsContainerState
} from "../../shared/HeaderTabsContainer";
import {PathComponent, PathProps} from "../../index";
import {GameStatsFragment} from "./GameStatsFragment";
import {Game} from "../types";

function createTabInfo(game: Game): TabInfo<GameTabType> {
  return {
    type: game.id as GameTabType,
    path: game.id,
    text: game.name,
    render: (path: PathProps) => <GameStatsFragment gameId={game.id} path={path}/>,
  }
}

const TABS: Tabs<GameTabType> = {
  items: GAMES.map(game => createTabInfo(game)),
  containerId: "stats",
};

type StatsTabsContainerProps = HeaderTabsContainerProps<GameTabType> & {}

type StatsTabsContainerState = HeaderTabsContainerState<GameTabType> & {}

class StatsTabsContainer extends HeaderTabsContainer<GameTabType, StatsTabsContainerProps, StatsTabsContainerState> {
}

export class StatsFragment extends FooterTabFragment {

  static nestedPaths(): PathComponent[] {
    return StatsTabsContainer.nestedPathsFromTabs(TABS);
  }

  getTitle(): string {
    return "Stats";
  }

  renderContent(): React.ReactElement | null {
    return <Box style={{display: "flex", flexGrow: 1}}>
      <StatsTabsContainer path={this.props.path} tabs={TABS}/>
    </Box>;
  }
}
